import React from "react";
import InputBox from "./InputBox";
import "./LoginPage.css";
import { Link } from "react-router-dom";
import { login, getUserData, getCurrentUser} from '../Utils/AuthUtils';
import { ACCESS_TOKEN } from '../Constants';
import WebPubLogo from '../Images/WebPub-logo.svg';

class LoginPage extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			usernameOrEmail: "",
			password: "",
			isLoading: false,
			isLogin: false,
			textType: "text",
			passwordType: "password",
			error: null,
			message : "",
		};
		
		// Method binding:
		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.fetchUsers = this.fetchUsers.bind(this);
	}

	handleChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	fetchUsers(logindata) {
		login(logindata)
			.then(response => {
				localStorage.setItem(ACCESS_TOKEN, response.accessToken);

				getCurrentUser()
				.then(
					curUser => {
						getUserData(curUser.id)
						.then(
							userData => {
								this.props.history.push("/masterpool");
								this.props.onSigninHandle(true, userData[0]);
							}
						);
					}
				)
				.catch(
					error => {
						if(error.status === 401) {
								this.setState({ error, isLoading: false, message : "The username or password you entered is incorrect."});
						}
					}
				);
			}
		)
		.catch(error => {
				if(error.status === 401) {
					this.setState({ error, isLoading: false, message : "The username or password you entered is incorrect."});
				}
			}
		);
	}								 

	onSubmit(e) {
		e.preventDefault();
		let logindata = {};

		if (this.state.usernameOrEmail !== "" && this.state.password !== "") {
			logindata.usernameOrEmail = this.state.usernameOrEmail;
			logindata.password = this.state.password;
			this.fetchUsers(logindata);
		} else {
			this.setState({ message : "Username and Password are mandatory fields."});
		}
	}

	render() {
		return (
			<div className="app-container">
				<div className="login-page">
					<Link to='/login'>
						<img src={WebPubLogo} alt="logo" style={{ height: 135, paddingTop: 10 }} />
					</Link>
					<div className="panel_center">
						<b>
							<font color="#e30707">Notice:</font> Do not give out, loan, or
							share your password with anyone. Allowing others access to your
							WebPub account may cause unauthorized access to
							private information. Access to educational records is governed by
							federal and state law.
						</b>
					</div>
					<form 
						className="panel_center login-form" 
						onSubmit={this.onSubmit}
					>
						<div className="panel_center_hdr">
							SIGN IN TO WEBPUB
						</div>
						<div>
							<InputBox
								fieldLabel="USERNAME or EMAIL:"
								name="usernameOrEmail"
								type={this.state.textType}
								value={this.state.usernameOrEmail}
								handleChange={this.handleChange}
							/>
						</div>
						<div>
							<InputBox
								fieldLabel="PASSWORD:"
								name="password"
								type={this.state.passwordType}
								value={this.state.password}
								handleChange={this.handleChange}
							/>
						</div>
						<p className = "displayMessage">{this.state.message} </p>
						<div className="actions">
							<button 
								className="actions_submit" 
								type='submit'
							>
								Sign In
							</button>
							<Link className="forgot_password" to="forgotpassword">
								Forgot Password?{" "}
							</Link>
						</div>
					</form>
				</div>
				<Footer />
			</div>
		);
	}
}
export default LoginPage;

// Copyright info that goes under every page
class Footer extends React.Component {
	render() {
		return (
			<div className='app-footer'>© {new Date().getFullYear()} University of Kansas</div>
		);
	}
}